export const language: any = {
    LabelLogin: "Anmelden",
    LabelForgotPw: "Passwort vergessen",
    LabelSignUp: "Mitglied werden",
    LabelRememberMe: "Angemeldet bleiben",
    Or: "oder",
    Email: "E-Mail",
    Password: "Passwort",
    LangKo: "Koreanisch",
    LangEn: "Englisch",
    LangVi: "Vietnamesisch",
    LabelCondition: "Den Allgemeinen Geschäftsbedingungen zustimmen",
    FullAgreement: "Vollständig zustimmen",
    Next: "Weiter",
    PrivacyPolicy: `Datenschutzrichtlinie <span class="text-[#ff6741]">(erforderlich)</span>`,
    TermOfUse: `Nutzungsbedingungen <label class="text-[#ff6741]">(erforderlich)</label>`,
    VerifyPassword: "Passwort bestätigen",
    PlaceHolderPassword: "Geben Sie mindestens 8 Buchstaben + Zahlen + Sonderzeichen ein",
    DuplicateCheck: "Doppelprüfung",
    LabelIdEmail: "ID (E-Mail)",
    GN_02_MSG_01: "Ihre App-Version ist veraltet. Bitte aktualisieren Sie, um sie weiter zu verwenden.",
    AU_02_MSG_02: "Diese E-Mail ist bereits registriert, bitte verwenden Sie eine andere E-Mail.",
    AU_02_MSG_03: "Die E-Mail ist verfügbar.",
    AU_02_MSG_01: "Bitte geben Sie ein gültiges E-Mail-Format ein.",
    AU_01_MSG_01: "Falsche ID oder falsches Passwort. Bitte versuchen Sie es erneut.",
    AU_02_MSG_04: "Bitte überprüfen Sie die verfügbare E-Mail.",
    AU_02_MSG_05: "Bitte geben Sie ein Passwort mit mindestens 8 Zeichen ein, einschließlich Buchstaben, Zahlen und Sonderzeichen.",
    AU_02_MSG_06: "Die Passwortbestätigung stimmt nicht überein.",
    AU_03_MSG_01: "Bitte geben Sie ein gültiges E-Mail-Format ein.",
    AU_03_MSG_02: "Die E-Mail ist nicht im System registriert.",
    AU_03_MSG_04: "※ Ein Bestätigungscode wurde an die registrierte E-Mail gesendet.",
    LabelRegisterComplete: "Die Registrierung ist abgeschlossen!",
    LabelLoginToUseService: "Melden Sie sich an und nutzen Sie den Service.",
    LabelDontRememberPassword: "Passwort vergessen?",
    LabelYouCanFindEmail: "Sie können es über die E-Mail-Verifizierung finden.",
    LabelPasswordTemporarySendToEmail: "※ Ein temporäres Passwort wird an die registrierte E-Mail gesendet.",
    SendVerifyNumber: "Bestätigungscode senden",
    LabelCheckYourEmailForTemporaryPassword: "Bitte überprüfen Sie Ihre E-Mail auf das temporäre Passwort.",
    PlaceHolderTemporaryPassword: "Temporäres Passwort eingeben",
    LabelTemporaryPassword: "Temporäres Passwort",
    LabelDidntReceiveYourPassword: "Haben Sie Ihr Passwort nicht erhalten?",
    LabelYouCanResendItAfter: "Sie können es erneut senden nach",
    LabelYouCanResendAgain: "Sie können es erneut senden.",
    Confirm: "Überprüfen",
    Resend: "Erneut senden",
    LabelResetPassword: "Passwort zurücksetzen",
    NewPassword: "Neues Passwort",
    ConfirmNewPassword: "Passwort bestätigen",
    PlaceHolderConfirmPassword: "Passwort bestätigen",
    CurrentPassword: "Aktuelles Passwort",
    LanguageSetting: "Spracheinstellung",
    LeaveMembership: "Mitgliedschaft kündigen",
    LabelConfirmPasswordToLeaveMemberShip: "Bitte geben Sie Ihr Passwort ein, um Ihre Mitgliedschaft zu kündigen.",
    LabelConfirmPasswordMeansYouAgreeAllContent: "Die Bestätigung Ihres Passworts bedeutet, dass Sie alle Anweisungen gelesen und ihnen zugestimmt haben.",
    LabelCancelMembership: "Mitgliedschaft kündigen",
    LabelBeforeLeaveYouCheckedContent: "Bevor Sie sich abmelden, müssen Sie die unten stehenden Anweisungen überprüfen und ihnen zustimmen.",
    LabelAfterLeaveAllInfoWillRemove: "Nach der Abmeldung werden alle Mitgliedsdaten und Nutzungshistorien gelöscht und können nicht wiederhergestellt werden.",
    LabelIHaveReadAndAgreeContent: "Ich habe alle Anweisungen gelesen und stimme ihnen zu.",
    ToUnsubscribe: "Abmelden",
    LabelWouldYouWantLogout: "Möchten Sie sich abmelden?",
    ChangePassword: "Passwort ändern",
    Menu: "Menü",
    MenuLanguageSettings: "Spracheinstellungen",
    MenuPrivacyPolicy: "Datenschutzrichtlinie",
    MenuLogout: "Abmelden",
    MenuLeaveMembership: "Mitgliedschaft kündigen",
    LabelAreYouSureLeaveMembership: "Sind Sie sicher, dass Sie sich abmelden möchten?",
    LabelIfLeaveMembershipAllInfoWillRemove: "Wenn Sie kündigen, werden Ihre Kontoinformationen gelöscht und können nicht wiederhergestellt werden.",
    LabelPrivacyPolicy: "Datenschutzrichtlinie",
    LabelTermOfUse: "Nutzungsbedingungen",
    MI_02_MSG_01: "Ihr aktuelles Passwort ist falsch.",
    LabelModalLogin: `Melden Sie sich an oder registrieren Sie sich, um auf diese Funktion zuzugreifen.`,
    LabelIdLogin: "ID-Anmeldung",
    LabelSnsApple: "Mit Apple fortfahren",
    LabelSnsFacebook: "Mit Facebook fortfahren",
    LabelSnsGoogle: "Mit Google fortfahren",
    LabelItemLogin: "Melden Sie sich an oder registrieren Sie sich, um eine <br/> Vielzahl von Funktionen mit Hey!Cooker zu erkunden.",
    LabelSnsEmail: "E-Mail-Anmeldung",
    LoadingLogin: "Bitte einen Moment warten.",
    MenuNotificationSettings: "Benachrichtigungseinstellungen"
  };
  